import Config from "react-global-configuration"

function useGlobalDashboard() {
  const { clientKiosk: kiosk, clientDevice: device } = Config.get()

  const showGlobalDashboard = !kiosk && !device

  return {
    showGlobalDashboard
  }
}

export { useGlobalDashboard }
